export const Coupon=
    [
        {
            "_id": "6239c6c95d7428146b7a6d60",
            "title": "Summer Gift Voucher",
            "couponCode": "SUMMER22",
            "endTime": "2022-05-30T12:54:00.000Z",
            "discountPercentage": 10,
            "minimumAmount": 500,
            "productType": "Cloths",
            "logo": "https://i.ibb.co/23kQcB9/ins3.jpg",
            "__v": 0,
            "createdAt": "2022-03-22T12:53:29.018Z",
            "updatedAt": "2022-03-22T12:54:53.790Z"
        },
        {
            "_id": "6239c6c95d7428146b7a6d5f",
            "title": "Winter Gift Voucher",
            "couponCode": "WINTER21",
            "endTime": "2022-10-31T20:19:00.000Z",
            "discountPercentage": 15,
            "minimumAmount": 500,
            "productType": "Grocery",
            "logo": "https://i.ibb.co/wBBYm7j/ins4.jpg",
            "__v": 0,
            "createdAt": "2022-03-22T12:53:29.018Z",
            "updatedAt": "2022-03-22T12:53:29.018Z"
        },
        {
            "_id": "6239c6c95d7428146b7a6d5e",
            "title": "Summer Gift Voucher",
            "couponCode": "SUMMER21",
            "endTime": "2021-07-20T00:56:00.000Z",
            "discountPercentage": 12,
            "minimumAmount": 600,
            "productType": "Cloths",
            "logo": "https://i.ibb.co/4thS4Z1/ins2.jpg",
            "__v": 0,
            "createdAt": "2022-03-22T12:53:29.017Z",
            "updatedAt": "2022-03-22T12:53:29.017Z"
        },
        {
            "_id": "6239c6c95d7428146b7a6d5d",
            "title": "August Gift Voucher",
            "couponCode": "AUGUST21",
            "endTime": "2021-08-31T06:00:00.000Z",
            "discountPercentage": 20,
            "minimumAmount": 1000,
            "productType": "Grocery",
            "logo": "https://i.ibb.co/PDLPDHc/ins1.jpg",
            "__v": 0,
            "createdAt": "2022-03-22T12:53:29.017Z",
            "updatedAt": "2022-03-22T12:53:29.017Z"
        }
    ]
